/* eslint-disable no-plusplus */
import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatNumber } from 'utils/formats';
import {
  TradingOfferSellerInfo,
  TradingOfferType,
} from '../../../../../types/TradingOffer';

type TradingOfferSellerInfoCardProps = {
  sellerInfo: TradingOfferSellerInfo;
  offerType: TradingOfferType;
};

const TradingOfferPublisherInfoCard: FC<TradingOfferSellerInfoCardProps> = ({
  sellerInfo,
  offerType,
}) => {
  const { t } = useTranslate();
  const isSellOffer = offerType === TradingOfferType.SELL;

  const initials = sellerInfo.name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <em
          key={i}
          className={`icon ni ${
            i <= rating ? 'ni-star-fill text-warning' : 'ni-star text-soft'
          }`}
        />
      );
    }
    return stars;
  };

  return (
    <div className="card card-bordered mb-4">
      <div className="card-inner">
        <h6 className="card-title mb-3">
          <em className="icon ni ni-user-circle text-primary mr-2" />
          {isSellOffer ? t('SellerInformation') : t('BuyerInformation')}
        </h6>

        <div className="d-flex align-items-center">
          <div className="user-avatar bg-primary-dim mr-3">
            {sellerInfo.image && (
              <img src={sellerInfo.image} alt={sellerInfo.name} />
            )}
            {!sellerInfo.image && !sellerInfo.memberSince && (
              <em className="icon ni ni-user" />
            )}
            {!sellerInfo.image && sellerInfo.memberSince && (
              <span>{initials}</span>
            )}
          </div>
          <div>
            <h6 className="mb-0">{sellerInfo.name}</h6>
            {sellerInfo.memberSince && (
              <span className="text-soft fs-13px">
                {t('MemberSince')}: {sellerInfo.memberSince}
              </span>
            )}
          </div>
        </div>

        <hr />

        <div className="row fs-13px">
          <div className="col-6 py-2">
            <span className="text-soft">{t('TotalShares')}:</span>
            <strong className="ml-1">
              {formatNumber(sellerInfo.totalShares)}
            </strong>
          </div>
          <div className="col-6 py-2">
            <span className="text-soft">{t('CapitalPercentage')}:</span>
            <strong className="ml-1">
              {sellerInfo.capitalPercentage.toFixed(2)}%
            </strong>
          </div>
          <div className="col-6 py-2">
            <span className="text-soft">{t('PreviousOperations')}:</span>
            <strong className="ml-1">{sellerInfo.previousOperations}</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingOfferPublisherInfoCard;
